export default __webpack_public_path__ + "static/media/check.1d1079d8.svg";